export default {
    methods: {
        __close_drawer(){
            this.$store.dispatch('ui/modal.close')
        }
    },
    mounted(){
        this.data = this.$store.getters['ui/modal'].data
    }
}